import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { UliActivityType } from '../../../common/constants';
import { DirectivesModule } from '../../../common/directives/directives.module';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-activity-type-selector',
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonToggleModule,
    ReactiveFormsModule,
    MatRadioModule,
    DirectivesModule,
  ],
  templateUrl: './activity-type-selector.component.html',
  styleUrls: ['./activity-type-selector.component.scss'],
})
export class ActivityTypeSelectorComponent<T> {
  @Input() activityTypeControl: FormControl<T>;
  @Input() fieldLabel: string;
  @Input() disabled = false;
  @Input() testId: string;

  uliActivityType = UliActivityType;
}
